module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione1.0e3c2794.svg";